<template>
    <tr>
        <td>{{ car.lot_date }}</td>
        <td>{{ car.auction_name}}</td>
        <td>{{ car.bid }}</td>
        <td>{{ car.company }}</td>
        <td>{{ car.model_name_en }}</td>
        <td>{{ car.model_type_en }}</td>
        <td>{{ car.model_year_en }}</td>
        <td>{{ purchaseStatus }}</td>
        <td>
            <button v-if="isLoading" class="button is-small date-select is-loading"></button>
            <purchase-status-column v-else :car="car"></purchase-status-column>
        </td>
    </tr>
</template>

<script>
    import PurchaseStatusColumn from './PurchaseStatusColumn'
    export default {
        props: ['car'],
        components: {
            PurchaseStatusColumn,
        },
        computed: {
            purchaseStatus() {
                if (this.car.purchase_payment_date) {
                    return 'PAID'
                } else {
                    return 'UNPAID'
                }
            },
            isLoading() {
                return this.$store.getters.getLoaderStatus
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 10px;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Purchases/PurchasesTableRow.vue